// JWT bearer-token storage. Keeps the token in localStorage so the
// session survives a page reload, and exposes a tiny pub/sub so the
// auth context can react to "I just signed in / out" without prop
// drilling.

const STORAGE_KEY = "realchem.token";

type Listener = (token: string | null) => void;

function read(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function write(token: string | null): void {
  try {
    if (token === null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // localStorage is unavailable (private browsing, ITP). Tokens
    // become session-only in that case; user has to re-sign in on
    // every reload.
  }
}

const listeners = new Set<Listener>();

export const tokenStore = {
  get: read,
  set(token: string | null): void {
    write(token);
    for (const cb of listeners) cb(token);
  },
  subscribe(cb: Listener): () => void {
    listeners.add(cb);
    return () => listeners.delete(cb);
  },
};
